import React from "react";
import { Button, ButtonProps } from "../ui/button";
import { cn } from "@/utils/cn";

export default function GifffButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      className={cn(
        "bg-amber-300/90 duration-300",
        props.className
      )}
    />
  );
}
